function GetPath() {
    var cururl = window.location.pathname;
    var lst = Math.max(cururl.lastIndexOf("/"), cururl.lastIndexOf("\\"));
    if (lst <= 0)
        return "";
    return cururl.substring(0, lst);
}

function HasExtensionDiv() {
    var ext = window.document.getElementById('priority-extension-is-installed-pre');
    if (typeof(ext) == 'undefined') return(false);
    if (ext == null) return(false);
    return true;
}

function HasPriorityVersion(plugin) {
     if (navigator.userAgent.indexOf('iPad') >= 0) return(true);
     if (navigator.userAgent.indexOf('Android') >= 0) return(true);
      if (!plugin) {
        var ext = window.document.getElementById('priority-extension-is-installed');
        if (typeof(ext) == 'undefined') return(false);
        if (ext == null) return(false);
        return true;
     }
     var PriorityVersion = "16.0";
     var p = window.document.getElementById('PriorityPlugin');
     if (typeof(p) == 'undefined') return(false);
     if (p == null) return(false);
     if (typeof(p.version) == 'undefined' || p.version!="17.3") return(false);
     return(p.version != "");
     //return(p.version == PriorityVersion);
}

function HasPriorityVersionPlugin() {
    var PriorityVersion = "16.3";
    var userAgentString = navigator.userAgent.match(/Priority H5 16.[0-9]+/g);
    return HasRuntimeVersion(PriorityVersion, userAgentString);
}

function HasRuntimeVersion(versionToCheck, userAgentString) {
    if (userAgentString != null) {
        var i;
        for (i = 0; i < userAgentString.length; ++i) {
            if (CompareVersions(GetVersion(versionToCheck),
	GetVersion(userAgentString[i])) <= 0)
                return true;
        }
    }
    return false;
}

//
// Extract the numeric part of the version string.
//
function GetVersion(versionString) {
    var numericString = versionString.match(/([0-9]+)\.([0-9]+)\.([0-9]+)/i);
    if (numericString == null)
        numericString = versionString.match(/([0-9]+)\.([0-9]+)/i);
    return numericString.slice(1);
}

//
// Compare the version strings by converting them to numeric format.
//
function CompareVersions(version1, version2) {
    for (i = 0; i < version1.length; ++i) {
        var number1 = new Number(version1[i]);
        var number2 = new Number(version2[i]);

        if (number1 < number2)
            return -1;
        if (number1 > number2)
            return 1;
    }
    return 0;
}

var dateFormat = function () {
	var	token = /d{1,4}|m{1,4}|yy(?:yy)?|([HhMsTt])\1?|[LloSZ]|"[^"]*"|'[^']*'/g,
		timezone = /\b(?:[PMCEA][SDP]T|(?:Pacific|Mountain|Central|Eastern|Atlantic) (?:Standard|Daylight|Prevailing) Time|(?:GMT|UTC)(?:[-+]\d{4})?)\b/g,
		timezoneClip = /[^-+\dA-Z]/g,
		pad = function (val, len) {
			val = String(val);
			len = len || 2;
			while (val.length < len) val = "0" + val;
			return val;
		};

	// Regexes and supporting functions are cached through closure
	return function (date, mask, utc) {
		var dF = dateFormat;

		// You can't provide utc if you skip other args (use the "UTC:" mask prefix)
		if (arguments.length == 1 && Object.prototype.toString.call(date) == "[object String]" && !/\d/.test(date)) {
			mask = date;
			date = undefined;
		}

		// Passing date through Date applies Date.parse, if necessary
		date = date ? new Date(date) : new Date;
		if (isNaN(date)) throw SyntaxError("invalid date");

		mask = String(dF.masks[mask] || mask || dF.masks["default"]);

		// Allow setting the utc argument via the mask
		if (mask.slice(0, 4) == "UTC:") {
			mask = mask.slice(4);
			utc = true;
		}

		var	_ = utc ? "getUTC" : "get",
			d = date[_ + "Date"](),
			D = date[_ + "Day"](),
			m = date[_ + "Month"](),
			y = date[_ + "FullYear"](),
			H = date[_ + "Hours"](),
			M = date[_ + "Minutes"](),
			s = date[_ + "Seconds"](),
			L = date[_ + "Milliseconds"](),
			o = utc ? 0 : date.getTimezoneOffset(),
			flags = {
				d:    d,
				dd:   pad(d),
				ddd:  dF.i18n.dayNames[D],
				dddd: dF.i18n.dayNames[D + 7],
				m:    m + 1,
				mm:   pad(m + 1),
				mmm:  dF.i18n.monthNames[m],
				mmmm: dF.i18n.monthNames[m + 12],
				yy:   String(y).slice(2),
				yyyy: y,
				h:    H % 12 || 12,
				hh:   pad(H % 12 || 12),
				H:    H,
				HH:   pad(H),
				M:    M,
				MM:   pad(M),
				s:    s,
				ss:   pad(s),
				l:    pad(L, 3),
				L:    pad(L > 99 ? Math.round(L / 10) : L),
				t:    H < 12 ? "a"  : "p",
				tt:   H < 12 ? "am" : "pm",
				T:    H < 12 ? "A"  : "P",
				TT:   H < 12 ? "AM" : "PM",
				Z:    utc ? "UTC" : (String(date).match(timezone) || [""]).pop().replace(timezoneClip, ""),
				o:    (o > 0 ? "-" : "+") + pad(Math.floor(Math.abs(o) / 60) * 100 + Math.abs(o) % 60, 4),
				S:    ["th", "st", "nd", "rd"][d % 10 > 3 ? 0 : (d % 100 - d % 10 != 10) * d % 10]
			};

		return mask.replace(token, function ($0) {
			return $0 in flags ? flags[$0] : $0.slice(1, $0.length - 1);
		});
	};
}();

// Some common format strings
dateFormat.masks = {
	"default":      "ddd mmm dd yyyy HH:MM:ss",
	shortDate:      "m/d/yy",
	mediumDate:     "mmm d, yyyy",
	longDate:       "mmmm d, yyyy",
	fullDate:       "dddd, mmmm d, yyyy",
	shortTime:      "h:MM TT",
	mediumTime:     "h:MM:ss TT",
	longTime:       "h:MM:ss TT Z",
	isoDate:        "yyyy-mm-dd",
	isoTime:        "HH:MM:ss",
	isoDateTime:    "yyyy-mm-dd'T'HH:MM:ss",
	isoUtcDateTime: "UTC:yyyy-mm-dd'T'HH:MM:ss'Z'"
};

// Internationalization strings
dateFormat.i18n = {
	dayNames: [
		"Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat",
		"Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"
	],
	monthNames: [
		"Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec",
		"January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"
	]
};

// For convenience...
Date.prototype.format = function (mask, utc) {
	return dateFormat(this, mask, utc);
};

function ServerTime()
{
	var dt = new Date(Date.UTC(serveryr, servermon, serverday, serverhr, servermin, serversec));	
	var fdate = dateFormat(dt, "dddd mmm d, yyyy HH:MM:ss");
	return fdate != "" ? fdate : dt.toLocaleString(); 
}

function CheckServerTime()
{
	var now = new Date(); 
	var clientDate = new Date(Date.UTC(now.getUTCFullYear(), now.getUTCMonth(), now.getUTCDate(),  now.getUTCHours(), now.getUTCMinutes(), 
		now.getUTCSeconds()));
    var serverDate = new Date(Date.UTC(serveryr, servermon, serverday, serverhr, servermin, serversec));
 
    return(Math.abs((clientDate.getTime() - serverDate.getTime()) / (1000 * 60)));
}
/*
function getInternetExplorerVersion()
// Returns the version of Internet Explorer or a -1
// (indicating the use of another browser).
{
  var rv = -1; // Return value assumes failure.
  if (navigator.appName == 'Microsoft Internet Explorer')
  {
    var ua = navigator.userAgent;
    var re  = new RegExp("MSIE ([0-9]{1,}[\.0-9]{0,})");
    if (re.exec(ua) != null)
      rv = parseFloat( RegExp.$1 );
  }
  return rv;
}

function checkIEVersion() 
{
    var ver = getInternetExplorerVersion();
    //alert("userAgent: " + navigator.userAgent + "\nversion: " + ver);
    if (ver > 0 && ver < 9) {
        alert("This software can't be run on Internet Explorer version 8.0 and lower");
        return false;
    }
    return true;
}
*/
function checkBrowserVersion()
{    
    //alert (navigator.userAgent);
    if (BrowserDetect.browser == "Explorer" && BrowserDetect.version > 0 && BrowserDetect.version < 10) {
        alert("This software can't be run on Internet Explorer version 9.0 and lower. If you are already using Internet Explorer 10 or higher, you may need to disable Compatibility View.");
        return false;
    }
    if (BrowserDetect.browser == "Explorer" && navigator.userAgent.indexOf("x64") !=-1) {
        alert("This software can't be run on Internet Explorer 64 bit");
        return false;
    }

    /* Grisha 26/02/13 - originally it was version 22 for Chrome, but on mobile we have 18 and it works */
    else if (BrowserDetect.browser == "Chrome" && BrowserDetect.version > 0 && BrowserDetect.version < 18) {
        alert("This software can't be run on Chrome version 17 and lower");
        return false;
    }
    else if (BrowserDetect.browser == "Firefox" && BrowserDetect.version > 0 && BrowserDetect.version < 15) {
        alert("This software can't be run on Firefox version 14 and lower");
        return false;
    }
    return true;
}

var BrowserDetect = {    
	init: function () {
		this.browser = this.searchString(this.dataBrowser) || "An unknown browser";
		this.version = this.searchVersion(navigator.userAgent)
			|| this.searchVersion(navigator.appVersion)
			|| "an unknown version";
		this.OS = this.searchString(this.dataOS) || "an unknown OS";
	},
	searchString: function (data) {
		for (var i=0;i<data.length;i++)	{
			var dataString = data[i].string;
			var dataProp = data[i].prop;
			this.versionSearchString = data[i].versionSearch || data[i].identity;
			if (dataString) {
				if (dataString.indexOf(data[i].subString) != -1)
					return data[i].identity;
			}
			else if (dataProp)
				return data[i].identity;
		}
	},
	searchVersion: function (dataString) {
		var index = dataString.indexOf(this.versionSearchString);
		if (index == -1) return;
		return parseFloat(dataString.substring(index+this.versionSearchString.length+1));
	},
	dataBrowser: [
		{
			string: navigator.userAgent,
			subString: "Edg/",
			versionSearch: "Edg/",
			identity: "Edge"
		},
		{
			string: navigator.userAgent,
			subString: "Chrome",
			identity: "Chrome"
		},
		{ 	string: navigator.userAgent,
			subString: "OmniWeb",
			versionSearch: "OmniWeb/",
			identity: "OmniWeb"
		},
		{
			string: navigator.vendor,
			subString: "Apple",
			identity: "Safari",
			versionSearch: "Version"
		},
		{
			prop: window.opera,
			identity: "Opera",
			versionSearch: "Version"
		},
		{
			string: navigator.vendor,
			subString: "iCab",
			identity: "iCab"
		},
		{
			string: navigator.vendor,
			subString: "KDE",
			identity: "Konqueror"
		},
		{
			string: navigator.userAgent,
			subString: "Firefox",
			identity: "Firefox"
		},
		{
			string: navigator.vendor,
			subString: "Camino",
			identity: "Camino"
		},
		{		// for newer Netscapes (6+)
			string: navigator.userAgent,
			subString: "Netscape",
			identity: "Netscape"
		},
		{
			string: navigator.userAgent,
			subString: "MSIE",
			identity: "Explorer",
			versionSearch: "MSIE"
		},
		{
			string: navigator.userAgent,
			subString: "Gecko",
			identity: "Mozilla",
			versionSearch: "rv"
		},
		{ 		// for older Netscapes (4-)
			string: navigator.userAgent,
			subString: "Mozilla",
			identity: "Netscape",
			versionSearch: "Mozilla"
		}
	],
	dataOS : [
		{
			string: getPlatform(),
			subString: "Win",
			identity: "Windows"
		},
		{
			string: getPlatform(),
			subString: "Mac",
			identity: "Mac"
		},
		{
			   string: navigator.userAgent,
			   subString: "iPhone",
			   identity: "iPhone/iPod"
	    },
		{
			string: getPlatform(),
			subString: "Linux",
			identity: "Linux"
		}
	]

};

function getPlatform() {
  var userPlatform;
  if (navigator.userAgentData) {
    userPlatform = navigator.userAgentData.platform;
  } else {
    userPlatform = navigator.platform;
  }
  return userPlatform;
}

var _is_ipad = -1;
function _isIpad() {
    if (_is_ipad == -1) {
        _is_ipad = (navigator.userAgent.indexOf('iPad') >= 0 ? 1 : 0);
    }
    return _is_ipad;
}
var _is_android = -1;
function _isAndroid() {
    if (_is_android == -1) {
        _is_android = (navigator.userAgent.indexOf('Android') >= 0 ? 1 : 0);
    }
    return _is_android;
}
var _is_mac = -1;
function _isMac() {
    if (_is_mac == -1) {
        _is_mac = (navigator.userAgent.indexOf('Macintosh')>= 0 || navigator.userAgent.indexOf('Linux') >= 0 ? 1 : 0);
    }
    return _is_mac;
}

function inlineManualUpdate(formname) {
    if (window.inline_manual_player) {
        window.inlineManualContext = formname;
        inline_manual_player.update();
    }
}

function inlineManualTracking(trackingData) {
    if (window.inline_manual_player) {
		inline_manual_player.setMetadata(trackingData);
        inline_manual_player.update();
    }
}